// extracted by mini-css-extract-plugin
export default {"tooltip":"CreateCampaignButton_tooltip__7EMhs","button":"CreateCampaignButton_button__60aJC"};